import { useTranslation } from "gatsby-plugin-react-i18next";

export default function SearchHeaderComponent({ searchState }) {
  const { t } = useTranslation();

  return searchState.query
    ? `${t("search-results-for")} ${searchState.query}`
    : t("search-results");
}
